import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AppProvider, useApp } from "./context/AppContext";
import Welcome from "./pages/Welcome";
import Home from "./pages/Home";
import Module from "./pages/Module";
import Bookmarks from "./pages/Bookmarks";


function Splash() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="serif text-3xl text-muted-foreground animate-pulse">
        Loading your training…
      </div>
    </div>
  );
}

function Shell() {
  const { loading, user } = useApp();
  if (loading) return <Splash />;
  return (
    <Routes>
      <Route path="/" element={user ? <Navigate to="/home" replace /> : <Welcome />} />
      <Route path="/home" element={user ? <Home /> : <Navigate to="/" replace />} />
      <Route path="/module/:id" element={user ? <Module /> : <Navigate to="/" replace />} />
      <Route
        path="/bookmarks"
        element={user ? <Bookmarks /> : <Navigate to="/" replace />}
      />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AppProvider>
        <BrowserRouter>
          <Shell />
          <Toaster richColors position="top-right" />
        </BrowserRouter>
      </AppProvider>
    </div>
  );
}
